export const BACKGROUND_TITLE = "Background";
export const SHADOW_TITLE = "Shadow";
export const DEVICE_TITLE = "Device";
export const DIMENSIONS_TITLE = "Dimensions";
